module.exports = __webpack_public_path__ + "img/freeNode.2534e1b7.svg";